import { Services } from "@/components/Services";

/** The offers, on their own page. The section's header is the page header. */
export default function ServicesPage() {
  return (
    <main
      className="bg-cream text-ink no-x pt-[76px]"
      data-testid="services-page"
    >
      <Services />
    </main>
  );
}
